'use strict';
var parent = require('../../es/instance/slice');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/instance/slice.js
// module id = 768
// module chunks = 13